import { Button } from "@/components/ui/button";
import { ClipboardPaste } from "lucide-react";
import { memo, useState } from "react";
import { AdHocPasteInDialog } from "./AdHocPasteInDialog";

export interface AdHocPasteInButtonProps {
  className?: string;
}

/**
 * Entry point for the ad hoc supplier item paste-in form (KAN-193).
 *
 * The caller (`CartPage`) is responsible for gating this on
 * `useIsConciergeOperator()` - this component renders unconditionally once
 * mounted, same split as `SaveCartAsListButton`/`SavedListNameDialog`: a
 * toolbar button that owns the dialog's open state.
 */
export const AdHocPasteInButton = memo(function AdHocPasteInButton({
  className
}: AdHocPasteInButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        className={className}
        onClick={() => setOpen(true)}
      >
        <ClipboardPaste className="mr-2 h-4 w-4" aria-hidden="true" />
        Add supplier item
      </Button>

      <AdHocPasteInDialog open={open} onOpenChange={setOpen} />
    </>
  );
});
